module.exports = __webpack_public_path__ + "img/flavor2.5eb6d272.png";